import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f09dd06")

_pushScopeId("data-v-3f09dd06")
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "flex-center margin-bottom-10" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = {
  key: 0,
  class: "flex"
}
const _hoisted_7 = {
  key: 1,
  class: "flex"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_cascader = _resolveComponent("el-cascader")
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")
  const _component_tag_input = _resolveComponent("tag-input")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_slice_selector = _resolveComponent("slice-selector")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      ref: "formDom",
      inline: true,
      "label-position": "right",
      "label-width": "80px",
      model: _ctx.formData
    }, {
      default: _withId(() => [
        _createVNode(_component_el_card, { class: "box-card margin-10" }, {
          default: _withId(() => [
            (_ctx.isEditing)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: "name",
                  rules: [{ required: true,message: '请输入名称',trigger: 'blur' }],
                  label: "名称"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.name = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              prop: "categoryIds",
              label: "匹配分类"
            }, {
              default: _withId(() => [
                (_ctx.isEditing)
                  ? (_openBlock(), _createBlock(_component_el_cascader, {
                      key: 0,
                      clearable: "",
                      filterable: "",
                      modelValue: _ctx.formData.categoryIds,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.categoryIds = $event)),
                      options: _ctx.sliceCategories,
                      props: {value: 'id', label: 'name', checkStrictly: true}
                    }, null, 8, ["modelValue", "options"]))
                  : (_openBlock(), _createBlock(_component_el_breadcrumb, {
                      key: 1,
                      style: {"line-height":"unset"},
                      separator: "/"
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categoryPath, (item) => {
                          return (_openBlock(), _createBlock(_component_el_breadcrumb_item, { key: item }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "tags",
              label: "匹配标签"
            }, {
              default: _withId(() => [
                (_ctx.isEditing)
                  ? (_openBlock(), _createBlock(_component_tag_input, {
                      key: 0,
                      alwaysShowInput: true,
                      modelValue: _ctx.formData.tags,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.tags = $event))
                    }, null, 8, ["modelValue"]))
                  : (_openBlock(), _createBlock("div", _hoisted_1, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.formData.tags, (tag) => {
                        return (_openBlock(), _createBlock(_component_el_tag, {
                          key: tag,
                          "disable-transitions": false
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(tag.name), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]))
              ]),
              _: 1
            }),
            (!_ctx.editable && _ctx.words)
              ? (_openBlock(), _createBlock("div", _hoisted_2, [
                  _createVNode("pre", null, _toDisplayString(_ctx.words), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_3, [
              (_ctx.isEditing)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    class: "margin-right-10",
                    type: "primary",
                    onClick: _ctx.onSubmit
                  }, {
                    default: _withId(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.currentSlot.id && _ctx.isEditing)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    onClick: _ctx.cancel
                  }, {
                    default: _withId(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    (_ctx.editable)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode(_component_el_button, {
            type: "warning",
            icon: "el-icon-plus",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('add-slot', _ctx.sortNumber + 1))),
            circle: ""
          }),
          (_ctx.currentSlot.id && !_ctx.isEditing)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isEditing=true)),
                icon: "el-icon-edit",
                circle: "",
                type: "primary"
              }))
            : _createCommentVNode("", true),
          (_ctx.showDelete)
            ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                key: 1,
                class: "block",
                onConfirm: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteSlot(_ctx.slotData))),
                title: "确定删除吗？"
              }, {
                reference: _withId(() => [
                  _createVNode(_component_el_button, {
                    type: "danger",
                    icon: "el-icon-delete",
                    circle: ""
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.editable)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode(_component_el_button, {
            type: _ctx.audio ? 'warning' : 'primary',
            icon: "el-icon-s-operation",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sliceDialogVisible = true))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.audio ? '切换' : '选择') + "段落", 1)
            ]),
            _: 1
          }, 8, ["type"]),
          (_ctx.audio)
            ? (_openBlock(), _createBlock("audio", {
                key: 0,
                class: "margin-left-10",
                src: _ctx.audio,
                controls: ""
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_slice_selector, {
      onSliceSelected: _ctx.handleSliceSelected,
      modelValue: _ctx.sliceDialogVisible,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.sliceDialogVisible = $event)),
      slotData: _ctx.slotData
    }, null, 8, ["onSliceSelected", "modelValue", "slotData"])
  ], 64))
})